import Layout from "../../components/Layout"
import DriverBy from "../../components/DriverBy"

const ReportDrivers = () => {
  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <DriverBy />
        </div>
      </main>
    </Layout>
  )
}

export default ReportDrivers
